var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5373 5.79201C14.6754 5.79201 14.796 5.75765 14.9342 5.68824C15.3135 5.46386 15.4342 4.99824 15.2105 4.63572C14.9861 4.25636 14.5205 4.13575 14.1579 4.35944C13.7786 4.56631 13.658 5.04944 13.8817 5.4288C14.0023 5.65387 14.261 5.792 14.5373 5.792V5.79201Z",
    fill: "#BFBFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5876 3.13488C11.7083 3.20361 11.8464 3.23865 11.9845 3.23865C12.2433 3.23865 12.5196 3.10052 12.657 2.84176C12.8639 2.47924 12.7433 1.99679 12.3807 1.78924C12.0014 1.58237 11.5358 1.70299 11.3114 2.06551C11.1052 2.44487 11.2258 2.91116 11.5876 3.13488V3.13488Z",
    fill: "#BFBFBF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49881 16.2449C12.777 16.2449 16.2437 12.7773 16.2437 8.50003C16.2437 8.06878 15.8987 7.72378 15.4675 7.72378C15.0362 7.72378 14.6912 8.06878 14.6912 8.50003C14.6912 11.9157 11.9136 14.6924 8.49881 14.6924C5.08314 14.6924 2.30641 11.9155 2.30641 8.50003C2.30641 5.08453 5.084 2.30763 8.49881 2.30763C8.93006 2.30763 9.27506 1.96263 9.27506 1.53138C9.27506 1.10013 8.93006 0.755127 8.49881 0.755127C4.22064 0.755127 0.753906 4.22203 0.753906 8.50003C0.753906 12.778 4.22081 16.2449 8.49881 16.2449Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLoading);
export default __webpack_public_path__ + "static/media/status-loading.5a558c33a73e82a85263e7b9fba2fa6c.svg";
export { ForwardRef as ReactComponent };